import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Profile } from '../../../../profiles/models/profile';
import { MojoWellKnownNames } from '../../../../common/constants/mojo-well-known-names';
import { ProfileService } from '../../../../profiles/services/profile.service';
import { takeWhile } from 'rxjs';
import { SupplierOtherCreditorService } from '@feature/suppliers/services/supplier-other-creditor.service';
import { SupplierOtherCreditorProfile } from '@admin/supplier-other-creditor/models/supplier-other-creditor-profile';
import { SupplierOtherCreditorEditorComponent } from
    '@admin/supplier-other-creditor/components/supplier-other-creditor-editor/supplier-other-creditor-editor.component';
import { ProductService } from '@common/services/product.service';

@Component({
  selector: 'mojo-supplier-other-creditor-admin-page',
    templateUrl: './supplier-other-creditor-admin-page.component.html',
})
export class SupplierOtherCreditorAdminPageComponent implements OnInit, OnDestroy {

  isAlive: boolean = true;
  pageTitle$: Observable<string>;
  dialogTitle: string;

    profiles$: Observable<Profile[]>;
    supplierOtherCreditorProfiles: Observable<SupplierOtherCreditorProfile[]>;
  supplierProfilesLoading$: Observable<boolean>;
    profileLoading$: Observable<boolean>;
    @ViewChild(SupplierOtherCreditorEditorComponent, { static: true }) editor;


  constructor(
    private profileService: ProfileService,
      private supplierOtherCreditorService: SupplierOtherCreditorService,
      private readonly productService: ProductService) {
    this.profileService.loadProfiles(MojoWellKnownNames.Products.MojoForSuppliers);
      this.supplierOtherCreditorService.load();
      this.supplierOtherCreditorProfiles = this.supplierOtherCreditorService.getSupplierOtherCreditorProfiles();
  }

  ngOnInit() {
      this.profiles$ = this.profileService.getAllProfiles(MojoWellKnownNames.Products.MojoForSuppliers);
      this.profileLoading$ = this.profileService.getLoading();
      this.supplierProfilesLoading$ = this.supplierOtherCreditorService.getLoading();
      this.pageTitle$ = this.productService.currentProductTitle('Assign a Profile to a Supplier', MojoWellKnownNames.Products.MojoForSuppliers);
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  saveComplete(event: any) {
    this.profileService.loadProfiles(MojoWellKnownNames.Products.MojoForSuppliers);
    this.supplierOtherCreditorService.load();
  }

  supplierOtherCreditorSelected(event: any) {
    this.showEditDialog(event);
  }

  showEditDialog(selectedSupplierOtherCreditor): void {
    this.dialogTitle = 'Client Properties';
      this.editor.showDialog(selectedSupplierOtherCreditor);
  }
}
